import { Stack, TextField } from '@mui/material';

import StepScreen from '@/karehero-app/access/StepScreen';
import { type Account } from '@/karehero-app/access/AccountBar';
import { QUESTIONS } from '@/karehero-app/onboarding/Onboarding.content';
import { RECIPIENT } from '@/karehero-app/tell-us-once/intake/content';

// Option 1, screen 3. A copy of onboarding's step 1, for the same reason as
// ForkScreen: a variant has to be free to change on its own.
const fieldProps = {
  fullWidth: true,
  slotProps: { inputLabel: { shrink: true } },
} as const;

const WhoScreen = ({
  onNext,
  onBack,
  account,
}: {
  onNext: () => void;
  onBack?: () => void;
  /** The app bar. See StepScreen's own `account`. */
  account?: Account;
}) => (
  <StepScreen
    account={account}
    title={QUESTIONS.carer['1']}
    primaryLabel='Next'
    onPrimary={onNext}
    onBack={onBack}
  >
    <Stack spacing={2}>
      <TextField label='Name' defaultValue={RECIPIENT} {...fieldProps} />
      <TextField label='Date of birth' {...fieldProps} />
      <TextField
        label='Relationship to you'
        defaultValue='Mother'
        {...fieldProps}
      />
    </Stack>
  </StepScreen>
);

export default WhoScreen;
